import { countries, SmartyAddress, MappedShippingAddress } from './types';

const getCountryFieldValue = (value: string) => {
  const country = {
    listValue: value,
    textValue: '',
  };
  if (value !== countries[0] && value !== countries[1]) {
    country.listValue = countries[2];
    country.textValue = value;
  }
  return country;
};

const isAddressInternational = (address: MappedShippingAddress): boolean => {
  if (!address.country) {
    return false;
  }
  return address.country !== countries[0] && address.country !== countries[1];
};

const mapSmartyAddress = (
  smartyAddress: SmartyAddress,
  existingAddress: MappedShippingAddress
): MappedShippingAddress => {
  return {
    ...existingAddress,
    street1: `${smartyAddress.primaryNumber ?? ''}${
      smartyAddress.streetPredirection
        ? ` ${smartyAddress.streetPredirection}`
        : ''
    } ${smartyAddress.streetName ?? ''} ${smartyAddress.streetSuffix ?? ''} ${
      smartyAddress.streetPostdirection ?? ''
    }`.trim(),
    street2:
      `${smartyAddress.secondaryDesignator ?? ''} ${
        smartyAddress.secondaryNumber ?? ''
      }`.trim() || '',
    city: smartyAddress.cityName ?? '',
    state: smartyAddress.state ?? '',
    zipcode: `${smartyAddress.zipCode ?? ''}` || '',
  };
};

const enteredAddressIsValid = (
  smartyAddress: SmartyAddress,
  existingAddress: MappedShippingAddress
): boolean => {
  return (
    existingAddress.country === 'United States' &&
    smartyAddress.street1 === existingAddress.street1 &&
    smartyAddress.street2 === existingAddress.street2 &&
    smartyAddress.city === existingAddress.city &&
    smartyAddress.state === existingAddress.state &&
    smartyAddress.zipcode === existingAddress.zipcode
  );
};

const validateShippingAccount = (
  accountNumber: string,
  service: string
): boolean => {
  let accountIsCorrect = true;
  if (!accountNumber) {
    return false;
  }
  if (service === 'fedex' || service === 'dhl') {
    if (accountNumber.length !== 9) {
      accountIsCorrect = false;
    }
    if (Number.isNaN(Number(accountNumber))) {
      accountIsCorrect = false;
    }
  } else if (service === 'ups') {
    if (accountNumber.length !== 6) {
      accountIsCorrect = false;
    }
    if (accountNumber.match(/^[a-z0-9]+$/i) === null) {
      accountIsCorrect = false;
    }
  }

  return accountIsCorrect;
};

export {
  getCountryFieldValue,
  isAddressInternational,
  mapSmartyAddress,
  enteredAddressIsValid,
  validateShippingAccount,
};
